import { sellerDisplay } from '../../lib/reportFormat';
import { TruncatedCell } from './TruncatedCell';

export function SellerCell({
  name,
  externalId,
}: {
  name: string | null;
  externalId: string | null;
}) {
  const display = sellerDisplay(name, externalId);
  const full = display.secondary ? `${display.primary} (${display.secondary})` : display.primary;
  return (
    <TruncatedCell value={full} className="max-w-full">
      <span className="flex min-w-0 max-w-full items-baseline gap-1">
        <span className="min-w-0 truncate">{display.primary}</span>
        {display.secondary ? (
          <span className="shrink-0 text-caption text-text-tertiary">({display.secondary})</span>
        ) : null}
      </span>
    </TruncatedCell>
  );
}
